import { ReactNode } from "react";

export const ComponentIgnoreOnPdf = ({ children, className }: { children: ReactNode; className?: string }) => {
  return (
    <div data-html2canvas-ignore="true" className={className}>
      {children}
    </div>
  );
};